import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommTimerIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M14.0853 1.4075C14.1021 1.4109 14.119 1.41431 14.1358 1.41771C19.0508 2.41093 22.75 6.76139 22.75 11.9775C22.75 17.9255 17.9387 22.7501 12 22.7501C6.06134 22.7501 1.25 17.9255 1.25 11.9775C1.25 8.96474 2.4852 6.23941 4.47436 4.28499C4.76983 3.99469 5.24468 3.99887 5.53498 4.29434C5.82528 4.5898 5.8211 5.06465 5.52564 5.35496C3.81208 7.03858 2.75 9.3829 2.75 11.9775C2.75 17.1002 6.89296 21.2501 12 21.2501C17.107 21.2501 21.25 17.1002 21.25 11.9775C21.25 7.48695 18.0654 3.74213 13.8387 2.88799C13.3935 2.79802 13.158 2.75337 12.9872 2.75026C12.8785 2.74828 12.8609 2.76378 12.8464 2.77654C12.845 2.77774 12.8437 2.77891 12.8423 2.78004C12.8324 2.78816 12.83 2.79159 12.8254 2.80075C12.8177 2.8161 12.801 2.85719 12.786 2.94883C12.7523 3.15522 12.75 3.44768 12.75 3.95947V4.96173C12.75 5.37594 12.4142 5.71173 12 5.71173C11.5858 5.71173 11.25 5.37594 11.25 4.96173V3.95947C11.25 3.94229 11.25 3.92516 11.25 3.90805C11.2499 3.46644 11.2498 3.04887 11.3056 2.70713C11.3699 2.31341 11.5216 1.92328 11.8909 1.62034L12.3666 2.20019L11.8909 1.62034C12.2415 1.33279 12.6238 1.24339 13.0146 1.25051C13.3389 1.25642 13.7114 1.33181 14.0853 1.4075ZM7.52646 6.41838C7.79897 6.1965 8.189 6.19358 8.4648 6.41136L13.8844 10.691C15.0335 11.5984 15.0395 13.3311 13.8965 14.2462C12.7602 15.1559 11.0637 14.7925 10.4103 13.4878L7.32939 7.33581C7.17204 7.0216 7.25395 6.64025 7.52646 6.41838ZM10.1791 9.67636L11.7515 12.8161C11.9742 13.2607 12.5625 13.3926 12.959 13.0752C13.3486 12.7633 13.3467 12.1777 12.9548 11.8682L10.1791 9.67636Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
